import { useState, useEffect, useCallback } from 'react';
import { Button } from '../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Loader2, Plus } from 'lucide-react';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';
import { meetingsAPI } from '../../lib/api';
import MeetingListRow from './MeetingListRow';
import MeetingCreateModal from './MeetingCreateModal';

export default function MyMeetingsTab() {
  const [meetings, setMeetings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState('all');
  const [showCreate, setShowCreate] = useState(false);
  const navigate = useNavigate();

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const params = { view: 'mine' };
      if (status !== 'all') params.status = status;
      const res = await meetingsAPI.list(params);
      setMeetings(res.data.meetings || []);
    } catch { toast.error('Failed to load your meetings'); }
    finally { setLoading(false); }
  }, [status]);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-4" data-testid="my-meetings-tab">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <Select value={status} onValueChange={setStatus}>
          <SelectTrigger className="w-44" data-testid="my-meetings-status-filter"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All statuses</SelectItem>
            <SelectItem value="PLANNED">Planned</SelectItem>
            <SelectItem value="REPORT_DUE">Report Due</SelectItem>
            <SelectItem value="SUBMITTED">Submitted</SelectItem>
            <SelectItem value="SENT_BACK">Sent Back</SelectItem>
            <SelectItem value="REVIEWED">Reviewed</SelectItem>
            <SelectItem value="CANCELLED">Cancelled</SelectItem>
          </SelectContent>
        </Select>
        <Button size="sm" onClick={() => setShowCreate(true)} data-testid="new-meeting-btn">
          <Plus className="h-4 w-4 mr-1.5" /> Plan or Log a Meeting
        </Button>
      </div>

      {loading ? (
        <div className="flex justify-center py-12"><Loader2 className="animate-spin" /></div>
      ) : meetings.length === 0 ? (
        <p className="text-sm text-muted-foreground text-center py-8" data-testid="no-my-meetings-msg">No meetings yet.</p>
      ) : (
        <div className="space-y-2">{meetings.map((m) => <MeetingListRow key={m.id} meeting={m} />)}</div>
      )}

      <MeetingCreateModal open={showCreate} onClose={() => setShowCreate(false)}
        onCreated={(m) => { setShowCreate(false); navigate(`/meetings/${m.id}`); }} />
    </div>
  );
}
